import React, { useState } from 'react';
import { FilterIcon, ChevronDownIcon, SearchIcon, SlidersIcon } from 'lucide-react';
export const ShopPage = () => {
  const [showFilters, setShowFilters] = useState(false);
  const products = [{
    id: 1,
    name: 'MacBook Pro 2021',
    category: 'electronics',
    condition: 'Refurbished - Excellent',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pVpXANE4MPeUTAwYJSN7su/Screenshot_2025-08-06_at_07.25.36.png',
    price: 1299,
    originalPrice: 1699,
    discount: '30%',
    tag: 'Featured'
  }, {
    id: 2,
    name: 'iPhone 14 Pro',
    category: 'electronics',
    condition: 'Refurbished - Like New',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bngTbbaTJ7wdgAETVR58Qf/Screenshot_2025-08-06_at_07.30.39.png',
    price: 899,
    originalPrice: 999,
    discount: '10%',
    tag: 'Popular'
  }, {
    id: 3,
    name: 'Gold Bar 1oz',
    category: 'gold',
    condition: 'Investment Grade - 99.99% Pure',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oaU7AVpzGveQuccM4pJ9vy/Screenshot_2025-08-06_at_07.29.11.png',
    price: 2084,
    originalPrice: null,
    discount: null,
    tag: 'Gold'
  }, {
    id: 4,
    name: 'Silver Coin Set',
    category: 'silver',
    condition: 'Investment Grade - 99.9% Pure',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oaU7AVpzGveQuccM4pJ9vy/Screenshot_2025-08-06_at_07.29.11.png',
    price: 599,
    originalPrice: null,
    discount: null,
    tag: 'Silver'
  }, {
    id: 5,
    name: 'Canon EOS R5',
    category: 'electronics',
    condition: 'Refurbished - Good',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bngTbbaTJ7wdgAETVR58Qf/Screenshot_2025-08-06_at_07.30.39.png',
    price: 2699,
    originalPrice: 3199,
    discount: '15%',
    tag: 'Featured'
  }, {
    id: 6,
    name: 'Platinum Bar 1oz',
    category: 'platinum',
    condition: 'Investment Grade - 99.95% Pure',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oaU7AVpzGveQuccM4pJ9vy/Screenshot_2025-08-06_at_07.29.11.png',
    price: 1054,
    originalPrice: null,
    discount: null,
    tag: 'Platinum'
  }, {
    id: 7,
    name: 'iPad Pro 12.9"',
    category: 'electronics',
    condition: 'Refurbished - Excellent',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pVpXANE4MPeUTAwYJSN7su/Screenshot_2025-08-06_at_07.25.36.png',
    price: 899,
    originalPrice: 1099,
    discount: '18%',
    tag: 'Popular'
  }, {
    id: 8,
    name: 'Silver Eagle 2023',
    category: 'silver',
    condition: 'Investment Grade - 99.9% Pure',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oaU7AVpzGveQuccM4pJ9vy/Screenshot_2025-08-06_at_07.29.11.png',
    price: 42,
    originalPrice: null,
    discount: null,
    tag: 'Silver'
  }];
  const tagColors = {
    Featured: 'green',
    Popular: 'blue',
    Gold: 'amber',
    Silver: 'gray',
    Platinum: 'purple'
  };
  return <div className="bg-gray-50 min-h-screen w-full" data-id="element-665">
      <div className="container mx-auto px-4 py-8" data-id="element-666">
        <h1 className="text-3xl font-bold mb-8" data-id="element-667">Shop Products</h1>
        {/* Search and Filter Bar */}
        <div className="bg-white rounded-lg shadow-sm p-4 mb-8" data-id="element-668">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4" data-id="element-669">
            <div className="relative flex-grow" data-id="element-670">
              <input type="text" placeholder="Search products..." className="w-full pl-10 pr-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent" data-id="element-671" />
              <SearchIcon size={20} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-672" />
            </div>
            <div className="flex items-center gap-2" data-id="element-673">
              <button onClick={() => setShowFilters(!showFilters)} className="flex items-center gap-2 bg-green-50 text-green-600 px-4 py-2 rounded-lg hover:bg-green-100 transition-colors" data-id="element-674">
                <FilterIcon size={18} data-id="element-675" />
                <span data-id="element-676">Filters</span>
              </button>
              <div className="relative" data-id="element-677">
                <select className="appearance-none bg-white border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent" data-id="element-678">
                  <option data-id="element-679">Sort: Featured</option>
                  <option data-id="element-680">Price: Low to High</option>
                  <option data-id="element-681">Price: High to Low</option>
                  <option data-id="element-682">Newest First</option>
                </select>
                <ChevronDownIcon size={16} className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" data-id="element-683" />
              </div>
            </div>
          </div>
          {/* Expanded Filters */}
          {showFilters && <div className="mt-4 pt-4 border-t border-gray-100 grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-684">
              <div data-id="element-685">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-686">
                  Category
                </label>
                <select className="w-full bg-white border border-gray-200 text-gray-700 py-2 px-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent" data-id="element-687">
                  <option value="" data-id="element-688">All Categories</option>
                  <option value="electronics" data-id="element-689">Electronics</option>
                  <option value="gold" data-id="element-690">Gold</option>
                  <option value="silver" data-id="element-691">Silver</option>
                  <option value="platinum" data-id="element-692">Platinum</option>
                </select>
              </div>
              <div data-id="element-693">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-694">
                  Condition
                </label>
                <select className="w-full bg-white border border-gray-200 text-gray-700 py-2 px-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent" data-id="element-695">
                  <option value="" data-id="element-696">Any Condition</option>
                  <option value="like-new" data-id="element-697">Like New</option>
                  <option value="excellent" data-id="element-698">Excellent</option>
                  <option value="good" data-id="element-699">Good</option>
                  <option value="fair" data-id="element-700">Fair</option>
                </select>
              </div>
              <div data-id="element-701">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-702">
                  Price Range
                </label>
                <div className="flex items-center gap-2" data-id="element-703">
                  <input type="number" placeholder="Min" className="w-full bg-white border border-gray-200 text-gray-700 py-2 px-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent" data-id="element-704" />
                  <span className="text-gray-400" data-id="element-705">-</span>
                  <input type="number" placeholder="Max" className="w-full bg-white border border-gray-200 text-gray-700 py-2 px-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent" data-id="element-706" />
                </div>
              </div>
              <div className="flex items-end" data-id="element-707">
                <button className="w-full bg-green-500 text-white py-2 px-4 rounded-lg hover:bg-green-600 transition-colors" data-id="element-708">
                  Apply Filters
                </button>
              </div>
            </div>}
        </div>
        {/* Product Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-709">
          {products.map(product => <div key={product.id} className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-710">
              <div className="p-4" data-id="element-711">
                <div className="relative" data-id="element-712">
                  <span className={`inline-block bg-${tagColors[product.tag]}-100 text-${tagColors[product.tag]}-600 text-xs font-semibold px-2 py-1 rounded-full mb-3`} data-id="element-713">
                    {product.tag}
                  </span>
                </div>
                <h3 className="font-semibold mb-1" data-id="element-714">{product.name}</h3>
                <p className="text-sm text-gray-500 mb-3" data-id="element-715">
                  {product.condition}
                </p>
                <div className="aspect-w-16 aspect-h-9 mb-4 flex items-center justify-center" data-id="element-716">
                  <img src={product.image} alt={product.name} className="object-contain h-32 mx-auto" data-id="element-717" />
                </div>
                <div className="flex items-center justify-between mb-3" data-id="element-718">
                  <div data-id="element-719">
                    <span className="text-lg font-bold" data-id="element-720">${product.price}</span>
                    {product.originalPrice && <span className="text-sm text-gray-500 line-through ml-2" data-id="element-721">
                        ${product.originalPrice}
                      </span>}
                  </div>
                  {product.discount && <span className={`text-${tagColors[product.tag]}-600 text-sm font-semibold`} data-id="element-722">
                      -{product.discount} OFF
                    </span>}
                </div>
                <button className={`w-full bg-${tagColors[product.tag]}-500 text-white py-2 rounded-lg hover:bg-${tagColors[product.tag]}-600 transition-colors`} data-id="element-723">
                  Add to Cart
                </button>
              </div>
            </div>)}
        </div>
        {/* Pagination */}
        <div className="flex justify-center mt-10" data-id="element-724">
          <nav className="inline-flex rounded-md shadow-sm" data-id="element-725">
            <button className="px-3 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 rounded-l-md" data-id="element-726">
              Previous
            </button>
            <button className="px-3 py-2 border-t border-b border-gray-300 bg-green-50 text-sm font-medium text-green-600" data-id="element-727">
              1
            </button>
            <button className="px-3 py-2 border-t border-b border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-728">
              2
            </button>
            <button className="px-3 py-2 border-t border-b border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-729">
              3
            </button>
            <button className="px-3 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 rounded-r-md" data-id="element-730">
              Next
            </button>
          </nav>
        </div>
      </div>
    </div>;
};